import {CreateProps} from "react-admin";
import {CustomCreate} from "../components/CustomCreate";
import {UserForm} from "./UserForm";


export const UserCreate = (props: CreateProps) => {
    return (
        <CustomCreate {...props}>
            <UserForm/>
        </CustomCreate>
    )
}